<template>
  <div>
    <div class="row mt-4">
      <div class="col">
        <p>
          Measurable outcomes are specific and include: (1) The knowledge, skill
          or attitude to be learned, (2) the specific change in the level of
          learning to be achieved (criteria, standard), and (3) a measure to
          show the desired outcome has been achieved with the funding.
        </p>
        <button class="btn btn-primary" v-on:click="showMeasurableOutcomeIdeas">
          Measurable Outcome Ideas
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col text-left">
        <div class="text-center mb-4">
          <h5>Response Templates</h5>
        </div>
        <ResponseCategories
          v-bind:ResponseCategories="responsesCategories"
          @addGrantApplicationResponse="addGrantApplicationResponse"
        />
      </div>
      <div v-if="grantApplication != null" class="col">
        <h5 class="mb-4">Grant Measurable Outcomes</h5>
        <div class="card">
          <div class="card-body text-left pt-0">
            <ResponsesToShow
              v-bind:Responses="responsesToShow"
              NoResponsesText="Use the templates to create grant measurable outcomes."
              @fillInBlank="fillInBlank"
              @removedApplicationResponse="applicationResponseRemoved"
            />
          </div>
        </div>
      </div>
    </div>
    <GrantResponseAnswerModal
      v-bind:ResponseToEdit="responseBlankToEdit"
      @responseAnswerModalClosed="responseAnswerModalClosed"
      @createdNewBlankAnswer="newBlankAnswerCreated"
      @createdNewResponseAnswer="newResponseAnswerCreated"
      @updatedResponseAnswer="responseAnswerUpdated"
    />
    <MeasurableOutcomeIdeasModal />
  </div>
</template>

<script>
import GrantResponseAnswerModal from "@/modals/MyGrants/GrantResponseAnswerModal.vue";
import ResponseCategories from "@/components/MyGrants/ResponseCategories";
import ResponsesToShow from "@/components/MyGrants/ResponsesToShow";
import MeasurableOutcomeIdeasModal from "@/modals/MyGrants/MeasurableOutcomeIdeasModal.vue";
import $ from "jquery";

export default {
  name: "ApplicationMeasurableOutcomes",
  components: {
    GrantResponseAnswerModal,
    ResponseCategories,
    ResponsesToShow,
    MeasurableOutcomeIdeasModal
  },
  props: {
    GrantApplication: Object
  },
  data() {
    return {
      responsesCategories: [],
      grantApplication: this.GrantApplication,
      responseBlankToEdit: null,
      responsesToShow: []
    };
  },
  watch: {
    GrantApplication: function() {
      this.grantApplication = this.GrantApplication;
      this.filterResponses();
    }
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    this.responsesCategories = await this.$getApplicationTemplateResponseCategories(
      1,
      true
    );
    this.filterResponses();
    this.$store.commit("updateLoading", false);
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
  },
  methods: {
    filterResponses() {
      this.responsesToShow = this.$filterResponsesToShow(
        this.responsesCategories,
        this.grantApplication.Grant_Application_Responses
      );
    },
    fillInBlank(responseBlankToEdit) {
      this.responseBlankToEdit = responseBlankToEdit;
      $("#questionResponseAnswerModal").modal("show");
    },
    async addGrantApplicationResponse(response) {
      var view = this;
      view.$store.commit("updateLoading", true);
      await view
        .$createGrantApplicationResponse(
          view.grantApplication.Grant_Application_Id,
          response.Application_Template_Response_Id
        )
        .then(appResponse => {
          view.responsesToShow.push(appResponse);
          this.$emit("responseCreated", appResponse);
        });
      view.$store.commit("updateLoading", false);
    },
    applicationResponseRemoved(response) {
      this.responsesToShow = this.responsesToShow.filter(
        r =>
          r.Grant_Application_Response_Id !=
          response.Grant_Application_Response_Id
      );
      this.$emit("responseRemoved", response);
    },
    responseAnswerModalClosed() {
      this.responseBlankToEdit = null;
    },
    newBlankAnswerCreated(newBlankAnswer) {
      var responseIndex = this.responsesToShow.findIndex(
        r =>
          r.Grant_Application_Response_Id ==
          this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
      this.responsesToShow[
        responseIndex
      ].Application_Template_Response.Template_Response_Blank_Answers.push(
        newBlankAnswer
      );
      this.$emit(
        "blankAnswerCreated",
        newBlankAnswer,
        this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
    },
    newResponseAnswerCreated(newResponseAnswer) {
      var responseIndex = this.responsesToShow.findIndex(
        r =>
          r.Grant_Application_Response_Id ==
          this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
      this.responsesToShow[
        responseIndex
      ].Grant_Application_Response_Answers.push(newResponseAnswer);
      this.$emit(
        "responseAnswerCreated",
        newResponseAnswer,
        this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
    },
    responseAnswerUpdated(updatedResponseAnswer) {
      var responseIndex = this.responsesToShow.findIndex(
        r =>
          r.Grant_Application_Response_Id ==
          this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
      var responseToUpdate = this.responsesToShow[responseIndex];
      var responseAnswerIndex = responseToUpdate.Grant_Application_Response_Answers.findIndex(
        a =>
          a.Grant_Application_Response_Answer_Id ==
          updatedResponseAnswer.Grant_Application_Response_Answer_Id
      );
      responseToUpdate.Grant_Application_Response_Answers[
        responseAnswerIndex
      ] = updatedResponseAnswer;
      this.$set(this.responsesToShow, responseIndex, responseToUpdate);
      this.$emit(
        "responseAnswerUpdated",
        updatedResponseAnswer,
        this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
    },
    showMeasurableOutcomeIdeas() {
      $("#measurableOutcomeIdeasModal").modal("show");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
